<template>
  <div
    :id="iuid"
    class="input pill"
    :class="{ selected }"
    @click="handleClick"
  >
    {{ label }}
  </div>
</template>

<script>
  let uid = 0;

  export default {
    name: 'Pill',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      value: {
        type: String,
        default: null,
      },
      checked: {
        type: [Array],
        default: () => [],
      },
      label: {
        type: String,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      uid += 1;
      return {
        selected: false,
        iuid: `pill-${uid}`,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    // computed: {},
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
      checked: {
        handler(val = []) {
          if (Array.isArray(val)) {
            this.selected = val.findIndex(e => e === this.value) !== -1;
          }
        },
        immediate: true,
      },
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    mounted() {
    },
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      handleClick() {
        const checked = this.checked.slice();
        const value = this.value;
        if (Array.isArray(checked)) {
          const index = checked.findIndex(e => e === value);
          if (index !== -1) {
            console.log('removing:', value);
            checked.splice(index, 1);
            this.selected = false;
          } else {
            console.log('adding:', value);
            checked.push(value);
            this.selected = true;
          }
          this.$emit('update:checked', checked);
        }
      },
      //----------------------------------
      // Event Handlers
      //----------------------------------
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.input.pill {
  border-radius: 12px;
  padding: 3px 7px 3px 7px;
  border: 1px solid black;
  font-size: 1.3rem;
  text-transform: uppercase;
  margin: 8px;
  user-select: none;
  cursor: pointer;
  background-color: transparent;
  color: black;
  transition: $default-transition;
  transition-property: background-color, color;

   &.selected {
     background-color: black;
     color: white;
   }
}
</style>
